// themes/inputs.js
import { validateRequired, validateLength } from "../../../../helpers/validationsForm";

const validateColor = (value) => {
  if (!value) return "El color es requerido";
  const isHex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(value);
  const isRgba = /^rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+(\s*,\s*[\d.]+)?\s*\)$/.test(value);
  if (!isHex && !isRgba) return "Ingresá un color válido (#fff, #ffffff o rgba(...))";
  return null;
};

const validatePx = (value) => {
  if (!value) return "El valor es requerido";
  if (!/^\d+px$/.test(value)) return "Ingresá un valor válido (ej: 8px)";
  return null;
};

const Inputs = [

  // ── Identificación ──────────────────────────────────────────────────────────
  {
    id: 1,
    label: "Descripción",
    name: "theme_descripcion",
    type: "text",
    placeholder: "Ej: Rojo Clásico",
    validation: (value) => {
      return validateRequired(value) || validateLength(value, { minLength: 2, maxLength: 100 });
    },
  },
  {
    id: 2,
    label: "Activo en Pagina Web",
    name: "theme_show_web",
    type: "select",
    options: [
      { value: 'true', label: 'Activo' },
      { value: 'false', label: 'Inativo' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
  // ── Colores principales ─────────────────────────────────────────────────────
  {
    id: 3,
    label: "Acento",
    name: "accent",
    type: "color",
    placeholder: "#e94560",
    validation: validateColor,
  },
  {
    id: 4,
    label: "Acento hover",
    name: "accent_hover",
    type: "color",
    placeholder: "#d63851",
    validation: validateColor,
  },
  {
    id: 5,
    label: "Acento suave (accent-soft)",
    name: "accent_soft",
    type: "text",
    placeholder: "rgba(233,69,96,0.08)",
    validation: validateColor,
  },
  {
    id: 6,
    label: "Color primario",
    name: "primary_color",
    type: "color",
    placeholder: "#1a1a2e",
    validation: validateColor,
  },
  {
    id: 7,
    label: "Color primario claro",
    name: "primary_light",
    type: "color",
    placeholder: "#16213e",
    validation: validateColor,
  },

  // ── Fondos ──────────────────────────────────────────────────────────────────
  {
    id: 8,
    label: "Fondo principal",
    name: "bg_main",
    type: "color",
    placeholder: "#f8f9fc",
    validation: validateColor,
  },
  {
    id: 9,
    label: "Fondo card",
    name: "bg_card",
    type: "color",
    placeholder: "#ffffff",
    validation: validateColor,
  },
  {
    id: 10,
    label: "Fondo elevado",
    name: "bg_elevated",
    type: "color",
    placeholder: "#ffffff",
    validation: validateColor,
  },
  {
    id: 11,
    label: "Fondo sutil",
    name: "bg_subtle",
    type: "color",
    placeholder: "#f1f3f8",
    validation: validateColor,
  },

  // ── Textos ──────────────────────────────────────────────────────────────────
  {
    id: 12,
    label: "Texto primario",
    name: "text_primary",
    type: "color",
    placeholder: "#1a1a2e",
    validation: validateColor,
  },
  {
    id: 13,
    label: "Texto secundario",
    name: "text_secondary",
    type: "color",
    placeholder: "#5a5f7a",
    validation: validateColor,
  },
  {
    id: 14,
    label: "Texto muted",
    name: "text_muted",
    type: "color",
    placeholder: "#8e92a4",
    validation: validateColor,
  },
  {
    id: 15,
    label: "Texto inverso",
    name: "text_inverse",
    type: "color",
    placeholder: "#ffffff",
    validation: validateColor,
  },

  // ── Bordes ──────────────────────────────────────────────────────────────────
  {
    id: 16,
    label: "Color borde",
    name: "border_color",
    type: "color",
    placeholder: "#e4e7f0",
    validation: validateColor,
  },
  {
    id: 17,
    label: "Borde hover",
    name: "border_hover",
    type: "color",
    placeholder: "#c8ccd8",
    validation: validateColor,
  },
  {
    id: 18,
    label: "Divisor",
    name: "divider",
    type: "color",
    placeholder: "#eef0f6",
    validation: validateColor,
  },

  // ── Semánticos ──────────────────────────────────────────────────────────────
  {
    id: 19,
    label: "Éxito",
    name: "success_color",
    type: "color",
    placeholder: "#10b981",
    validation: validateColor,
  },
  {
    id: 20,
    label: "Advertencia",
    name: "warning_color",
    type: "color",
    placeholder: "#f59e0b",
    validation: validateColor,
  },
  {
    id: 21,
    label: "Peligro",
    name: "danger_color",
    type: "color",
    placeholder: "#ef4444",
    validation: validateColor,
  },
  {
    id: 22,
    label: "Info",
    name: "info_color",
    type: "color",
    placeholder: "#3b82f6",
    validation: validateColor,
  },
  {
    id: 23,
    label: "Violeta",
    name: "purple_color",
    type: "color",
    placeholder: "#7c3aed",
    validation: validateColor,
  },

  // ── Tipografías ─────────────────────────────────────────────────────────────
  {
    id: 24,
    label: "Fuente títulos (font-heading)",
    name: "font_heading",
    type: "text",
    placeholder: "Plus Jakarta Sans, sans-serif",
    validation: (value) => validateRequired(value) || validateLength(value, { maxLength: 100 }),
  },
  {
    id: 25,
    label: "Fuente cuerpo (font-body)",
    name: "font_body",
    type: "text",
    placeholder: "DM Sans, sans-serif",
    validation: (value) => validateRequired(value) || validateLength(value, { maxLength: 100 }),
  },
  {
    id: 26,
    label: "Fuente mono (font-mono)",
    name: "font_mono",
    type: "text",
    placeholder: "Space Grotesk, monospace",
    validation: (value) => validateRequired(value) || validateLength(value, { maxLength: 100 }),
  },

  // ── Radio ───────────────────────────────────────────────────────────────────
  {
    id: 27,
    label: "Radio sm",
    name: "radius_sm",
    type: "text",
    placeholder: "8px",
    validation: validatePx,
  },
  {
    id: 28,
    label: "Radio md",
    name: "radius_md",
    type: "text",
    placeholder: "12px",
    validation: validatePx,
  },
  {
    id: 29,
    label: "Radio lg",
    name: "radius_lg",
    type: "text",
    placeholder: "16px",
    validation: validatePx,
  },
  {
    id: 30,
    label: "Radio xl",
    name: "radius_xl",
    type: "text",
    placeholder: "20px",
    validation: validatePx,
  },

  // ── Footer ──────────────────────────────────────────────────────────────────
  {
    id: 31,
    label: "Copyright footer",
    name: "footer_copyright",
    type: "text",
    placeholder: "© 2025 Mi Empresa",
    validation: (value) => validateLength(value, { maxLength: 255 }),
  },
  {
    id: 32,
    label: "Dirección footer",
    name: "footer_address",
    type: "text",
    placeholder: "Av. Siempre Viva 742",
    validation: (value) => validateLength(value, { maxLength: 255 }),
  },
];

export default Inputs;